module.exports = __webpack_public_path__ + "static/img/evaluation_holland.ba2ae644.jpg";